import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'leadingZero' })
export class LeadingZeroPipe implements PipeTransform {
    transform(value: any): string {
        let converted: number;

        if (typeof value !== 'number') {
            converted = Number(value);

            if (Number.isNaN(converted)) { return value; }

        } else {
            converted = value;
        }
        let finalValue: string = `${converted}`;

        if (converted < 10 && converted >= 0) {
            finalValue = `0${converted}`;
        }

        if (converted < 0 && converted > -10) {
            finalValue = `-0${-1 * converted}`;
        }

        return finalValue;
    }
}
